import { FC } from 'react'
import { Navigate, Outlet, redirect } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
import './pledge.css'

// COMPONENTS
import { Column } from '@components/templates/column'

// ROUTES
import { PledgeDefaultRoute } from './default'
import { PMRoute } from './pm'
import PledgeReviewRoute from './review'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { parseUserLimits } from '@schemas'
import { createAuthenticatedLoader, refreshClerkUser } from '@utils/loaders'
import { getGroupStatus } from '@utils/temp-helpers'
import { isNonEmptyString } from '@utils/type-checkers'
import { useGroupLoaderData, usePledgeOutletContext } from '../'


const Component: FC<{}> = () => {
    const { user: clerkUser, isSignedIn } = useUser()
    const context = usePledgeOutletContext()
    const group = useGroupLoaderData()
    const { groupStatus } = getGroupStatus(group)

    const { organizer } = group
    const isOrganizer = isSignedIn ? organizer?.id === clerkUser.id : false

    const hasPledge = !!group.pledges?.find(({ user }) => (user?.id === clerkUser?.id))

    if (isOrganizer || hasPledge || groupStatus !== 'active') return <Navigate to={`/group/${group.id}`} replace={true} />
    else return (<>
        <Column.Content className="group-pledge-screen">
            <Outlet context={context} />
        </Column.Content>
    </>)
}

const loader = createAuthenticatedLoader(async ({ params }, Clerk) => {
    await refreshClerkUser(Clerk)
    const userLimits = parseUserLimits(Clerk.user?.publicMetadata?.limits)
    if (!userLimits.joinGroups && isNonEmptyString(params.groupId)) {
        return redirect(`/group/${params.groupId}`)
    }

    return null
})

const PledgeRoute: RouteObject = {
    path: "pledge",
    Component,
    loader,
    children: [
        PledgeDefaultRoute,
        PMRoute,
        PledgeReviewRoute
    ],
}

export default PledgeRoute
